module.exports = __webpack_public_path__ + "static/media/25-mercedes.d4cdb066.jpg";